import { useTheme } from "../../context/ThemeContext";

export default function CategoriesTable({
    categories,
    onEdit,
    onDelete,
    deletingId,
}) {

    const { isDark } = useTheme();

    return (

        <div
            className={`
                overflow-hidden
                rounded-3xl
                border
                ${
                    isDark
                        ? "border-white/10"
                        : "border-gray-200"
                }
            `}
        >

            <table className="w-full">

                <thead
                    className={
                        isDark
                            ? "bg-white/5"
                            : "bg-gray-50"
                    }
                >

                    <tr>

                        <th className="p-4 text-left">
                            Name
                        </th>

                        <th className="p-4 text-left">
                            Slug
                        </th>

                        <th className="p-4 text-left">
                            Posts
                        </th>

                        <th className="p-4 text-left">
                            Actions
                        </th>

                    </tr>

                </thead>

                <tbody>

                    {categories.length === 0 ? (

                        <tr>

                            <td
                                colSpan={4}
                                className="
                                    p-8
                                    text-center
                                    opacity-60
                                "
                            >
                                No categories found.
                            </td>

                        </tr>

                    ) : (

                        categories.map((category) => (

                            <tr
                                key={category.id}
                                className={`
                                    border-t
                                    ${
                                        isDark
                                            ? "border-white/10"
                                            : "border-gray-200"
                                    }
                                `}
                            >

                                <td className="p-4 font-medium">
                                    {category.name}
                                </td>

                                <td className="p-4">
                                    {category.slug}
                                </td>

                                <td className="p-4">
                                    {category.posts}
                                </td>

                                <td className="p-4">

                                    <div className="flex gap-3">

                                        <button
                                            onClick={() => onEdit(category)}
                                            className="text-blue-700"
                                        >
                                            Edit
                                        </button>

                                        <button
                                            onClick={() => onDelete(category.id)}
                                            disabled={
                                                deletingId === category.id
                                            }
                                            className="
                                                text-red-500
                                                disabled:opacity-50
                                            "
                                        >
                                            {deletingId === category.id
                                                ? "Deleting..."
                                                : "Delete"}
                                        </button>

                                    </div>

                                </td>

                            </tr>

                        ))

                    )}

                </tbody>

            </table>

        </div>

    );

}